var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout--full-page"},[_c('child')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }